import API from "@/api";

//上传配置

export default {
	apiObj: API.common.upload,			//上传请求API对象
	filename: "file",					//form请求时文件的key
	successCode: 200,					//请求完成代码
	maxSize: 10000,						//最大文件大小 默认10MB
	parseData: function (res) {
		return {
			code: res.code,				//分析状态字段结构
			fileName: res.data[0].fileName,//分析文件名称
			src: res.data[0].picURL,			//分析图片远程地址结构
			base: res.data[0].base,			//图片id
			msg: res.message			//分析描述字段结构
		}
	},
	apiObjFile: API.common.uploadFile,	//附件上传请求API对象
	maxSizeFile: 10000						//最大文件大小 默认10MB
}
